<template>
  <div id="layoutAuthentication">
    <div id="layoutAuthentication_content">
      <main>
        <div class="container">
          <div class="row justify-content-center text-center">
            <div class="col-lg-5">
              <div class="card shadow-lg border-0 rounded-lg mt-5">
                <div class="card-header">
                  <div class="row">
                    <div class="col-2">
                      <img class="img-fluid mr-0" :src="krbsLogo" />
                    </div>
                    <div class="col-9">
                      <p style="font-size : 0.7em!important;">"K" LINE RORO BULK SHIP MANAGEMENT CO., LTD.</p>
                      <p class="font-weight-bold">TURN OVER NOTES SYSTEM</p>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <form @submit.prevent="thisLogin">
                    <div class="form-group row">
                      <div class="col-md-12 text-left">
                        <label class="col-form-label font-weight-bold">
                          <font-awesome-icon icon="shield-alt" />
                          Login as
                        </label>
                        <select id="login-selection" class="form-control form-control-sm" required
                                v-model="authFormData.logAs"
                                v-focus
                                data-toggle="tooltip"
                                data-placement="right"
                                title="Please select account type in the list">
                          <option :value="logAs.val" v-for="(logAs,index) in logAsOptions" :key="index"
                                  :selected="logAs.val == authFormData.logAs">
                            {{ logAs.display }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="form-group row mt-2">
                      <div class="col-md-12 text-left">
                        <label class="col-form-label font-weight-bold" for="input-username">
                          <font-awesome-icon icon="user-shield" />
                          <span>Username</span>
                        </label>
                        <input class="form-control form-control-sm"
                               id="input-username"
                               name="inputUsername"
                               type="text"
                               placeholder="Enter username"
                               @keypress.enter="logIn"
                               v-model="authFormData.username"
                               required
                        />
                      </div>
                    </div>

                    <div class="form-group row mt-4">
                      <div class="col-md-12 text-left">
                        <label class="col-form-label  font-weight-bold" for="input-password">
                          <font-awesome-icon icon="key" />
                          Password
                        </label>
                        <div class="input-group">
                          <input class="form-control form-control-sm"
                                 id="input-password"
                                 name="inputPassword"
                                 type="password"
                                 placeholder="Enter password"
                                 autocomplete="on"
                                 @keypress.enter="logIn"
                                 v-model="authFormData.password"
                                 required
                          />
                          <div class="input-group-append">
                            <button class="btn btn-sm btn-secondary" type="button" title="Show Password"
                                    @click="showPassword">
                              <font-awesome-icon :icon="this.icon" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <button class="btn btn-primary" type="submit">
                        <font-awesome-icon v-if="!isLoading" icon="right-from-bracket" />
                        <font-awesome-icon v-if="isLoading" icon="spinner" spin />
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>

    <div id="layoutAuthentication_footer">
      <base-app-footer />
    </div>
  </div>
</template>

<script>

import krbsLogo from '../assets/krbsicon.png';
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'Login',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      krbsLogo: krbsLogo,
      icon: 'eye-slash',
      logAsOptions: [
        {id: 0, val: null, display: '---'},
        {id: 1, val: 1, display: 'S.I'},
        {id: 2, val: 2, display: 'Principal'},
        {id: 3, val: 3, display: 'Manning'},
        {id: 4, val: 4, display: 'Crew'},
      ],
    };
  },

  /** methods**/
  methods: {
    ...mapActions(['reset_auth_form_data', 'login']),
    thisLogin() {
      this.login(this.authFormData).then((r) => {
        if (r) {

          console.log('This is auth post id',this.authPos.id);

          this.$nextTick(()=>{
            switch (this.authPos.id) {
              case 1:
              case 2:
              case 3:
              case 4:
                this.$router.push({name: 'Main'});
                break;

              case 5:
                this.$router.push({name: 'CrewViewTon',params : {crewTonId : this.crewTonId}});
                break;
            }
          })
        }
      });
    },

    showPassword() {
      const input = document.getElementById('input-password');
      if (input.type == 'password') {
        input.type = 'text';
        this.icon = 'eye';

      } else {
        input.type = 'password';
        this.icon = 'eye-slash';
      }
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters([
      'authFormData',
      'isLoading',
      'authPos',
      'crewTonId',
    ]),
  },

  /** mounted **/
  mounted() {
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },

  /** created **/
  created() {
  },

  /** watch
   searchText : {
			handler : 'fetchUserList',
			immediate : true,
		}
   **/
  watch: {},

  /** destroyed **/
  destroyed() {
    this.reset_auth_form_data();
  },

};
</script>

<style scoped>
img {
  max-height: 40px !important;
  max-width: 40px !important;
}

p {
  margin-bottom: 0 !important;
}
</style>
